// Dados Mestres Oficiais e Fallback Resiliente da Loja URB
export const INITIAL_CATEGORIES = [
      { id: 'cat_todos', name: 'Todos os produtos', slug: 'todos', description: 'Linha completa oficial URBRACE', order: 0 },
      { id: 'cat_camisas', name: 'Camisas', slug: 'camisas', description: 'Camisas técnicas de alta respirabilidade e caimento anatômico', order: 1 },
      { id: 'cat_bones', name: 'Bonés', slug: 'bones', description: 'Bonés laser tech e viseiras ultraleves com proteção solar', order: 2 },
      { id: 'cat_meias', name: 'Meias', slug: 'meias', description: 'Compressão graduada 21K e tecnologia anti-bolha', order: 3 },
      { id: 'cat_manguitos', name: 'Manguitos', slug: 'manguitos', description: 'Proteção UV50+ e suporte térmico muscular', order: 4 },
      { id: 'cat_acessorios', name: 'Acessórios', slug: 'acessorios', description: 'Cintos de hidratação, porta celular touch e equipamentos', order: 5 },
      { id: 'cat_kits', name: 'Kits', slug: 'kits', description: 'Combos completos de performance e maratona', order: 6 }
    ];

export const INITIAL_SHIPPING_METHODS = [
      {
        id: 'ship_retirada',
        code: 'retirada',
        name: 'Retirada Oficial URBRACE',
        description: 'Retire gratuitamente no balcão de provas ou tenda oficial da corrida',
        base_cost: 0.00,
        estimated_days: 1
      },
      {
        id: 'ship_local',
        code: 'entrega_local',
        name: 'Entrega Expressa URB (Motoboy)',
        description: 'Receba em até 24h na Grande SP e região metropolitana',
        base_cost: 14.90,
        estimated_days: 1
      },
      {
        id: 'ship_pac',
        code: 'correios_pac',
        name: 'Transportadora Padrão (PAC)',
        description: 'Envio seguro com rastreamento para todo o Brasil',
        base_cost: 22.50,
        estimated_days: 5
      },
      {
        id: 'ship_sedex',
        code: 'correios_sedex',
        name: 'SEDEX Expresso Premium',
        description: 'Prioridade máxima de envio com entrega em 1 a 2 dias úteis',
        base_cost: 38.90,
        estimated_days: 2
      }
    ];

export const INITIAL_COUPONS = [
    { id: 'coup_01', code: 'URB10', type: 'percentage', value: 10, min_order_amount: 50.00, max_uses: 500, start_date: '2026-01-01', end_date: '2026-12-31' },
    { id: 'coup_02', code: 'CORRE20', type: 'fixed', value: 20.00, min_order_amount: 150.00, max_uses: 250, start_date: '2026-01-01', end_date: '2026-12-31' },
    { id: 'coup_03', code: 'FRETEGRATIS', type: 'free_shipping', value: 0, min_order_amount: 120.00, max_uses: 1000, start_date: '2026-01-01', end_date: '2026-12-31' }
  ];

export const INITIAL_PRODUCTS = [
    {
      id: 'prod_camisa_perf',
      category_id: 'cat_camisas',
      name: 'Camisa Performance Dry-Fit URB',
      slug: 'camisa-performance-dry-fit-urb',
      short_description: 'Tecido ultraleve respirável com proteção UV50+ e detalhes reflexivos para corridas noturnas.',
      description: 'Desenvolvida especialmente para os atletas que buscam quebrar seus recordes pessoais. Confeccionada com microfibra de poliamida aerodinâmica e tecnologia Dry-Fit de absorção imediata, mantém a temperatura corporal estável até mesmo nas provas mais duras. O acabamento com costuras planas flatlock impede qualquer atrito com a pele.',
      technical_info: 'Composição: 90% Poliamida Ultraleve, 10% Elastano. Fator de proteção solar UV50+. Tratamento antibacteriano com íons de prata. Elementos refletivos 3M nos ombros e costas.',
      size_guide: 'Tabela de Medidas (Tórax x Comprimento):\nP: 92cm x 68cm\nM: 98cm x 71cm\nG: 106cm x 74cm\nGG: 114cm x 77cm\nXG: 122cm x 80cm',
      price: 119.90,
      promotional_price: 99.90,
      sku: 'URB-CAM-PERF',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 38,
      images: [
        { url: '/images/produtos/camisa-urb.png', is_primary: 1 },
        { url: '/assets/products/camisa-performance-grafite.svg', is_primary: 0 },
        { url: '/assets/products/camisa-performance-neon.svg', is_primary: 0 }
      ],
      variants: [
        { size: 'P', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 10, sku: 'URB-CAM-P-BLK' },
        { size: 'M', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 15, sku: 'URB-CAM-M-BLK' },
        { size: 'G', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 20, sku: 'URB-CAM-G-BLK' },
        { size: 'GG', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 8, sku: 'URB-CAM-GG-BLK' },
        { size: 'P', color: 'Grafite Carbon', color_hex: '#1b221e', gender: 'Unissex', stock: 12, sku: 'URB-CAM-P-GRA' },
        { size: 'M', color: 'Grafite Carbon', color_hex: '#1b221e', gender: 'Unissex', stock: 18, sku: 'URB-CAM-M-GRA' },
        { size: 'G', color: 'Grafite Carbon', color_hex: '#1b221e', gender: 'Unissex', stock: 14, sku: 'URB-CAM-G-GRA' },
        { size: 'P', color: 'Verde Neon Flash', color_hex: '#b0ff00', gender: 'Unissex', stock: 10, sku: 'URB-CAM-P-NEO' },
        { size: 'M', color: 'Verde Neon Flash', color_hex: '#b0ff00', gender: 'Unissex', stock: 25, sku: 'URB-CAM-M-NEO' },
        { size: 'G', color: 'Verde Neon Flash', color_hex: '#b0ff00', gender: 'Unissex', stock: 15, sku: 'URB-CAM-G-NEO' },
        { size: 'XG', color: 'Verde Neon Flash', color_hex: '#b0ff00', gender: 'Unissex', stock: 0, sku: 'URB-CAM-XG-NEO' }
      ]
    },
    {
      id: 'prod_regata_marathon',
      category_id: 'cat_camisas',
      name: 'Regata Pro Marathon URBRACE',
      slug: 'regata-pro-marathon-urbrace',
      short_description: 'Máxima ventilação e liberdade para treinos intensos e dias de maratona.',
      description: 'Modelagem anatômica cavada nas costas estilo nadador para amplitude total nos movimentos dos braços. Painel posterior em mesh ultrafino que maximiza a evaporação do suor sob altas temperaturas.',
      technical_info: 'Composição: 92% Poliamida, 8% Elastano. Painéis traseiros em Mesh Breathe-Zone. Peso aproximado: 75 gramas. Secagem ultrarrápida.',
      size_guide: 'Tabela de Medidas:\nP: Busto 88cm x Altura 66cm\nM: Busto 94cm x Altura 69cm\nG: Busto 102cm x Altura 72cm\nGG: Busto 110cm x Altura 75cm',
      price: 99.90,
      promotional_price: 84.90,
      sku: 'URB-REG-MARA',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.8,
      rating_count: 24,
      images: [
        { url: '/assets/products/regata-marathon-preta.svg', is_primary: 1 }
      ],
      variants: [
        { size: 'P', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Masculino', stock: 12, sku: 'URB-REG-M-P-BLK' },
        { size: 'M', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Masculino', stock: 16, sku: 'URB-REG-M-M-BLK' },
        { size: 'G', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Masculino', stock: 10, sku: 'URB-REG-M-G-BLK' },
        { size: 'P', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Feminino', stock: 8, sku: 'URB-REG-F-P-BLK' },
        { size: 'M', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Feminino', stock: 14, sku: 'URB-REG-F-M-BLK' },
        { size: 'G', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Feminino', stock: 9, sku: 'URB-REG-F-G-BLK' }
      ]
    },
    {
      id: 'prod_manga_longa',
      category_id: 'cat_camisas',
      name: 'Camisa Manga Longa Tech UV50+',
      slug: 'camisa-manga-longa-tech-uv50',
      short_description: 'Proteção térmica e solar inteligente com abertura para polegar e caimento justo.',
      description: 'Projetada para treinos matinais gelados ou provas de montanha sob sol escaldante. As mangas estendidas possuem encaixe para o polegar que impedem o deslocamento da manga durante a corrida.',
      technical_info: 'Composição: 88% Poliamida, 12% Spandex. Proteção UVA/UVB FPU 50+ permanente. Acabamento anti-odor e costuras reforçadas.',
      size_guide: 'Tamanho regular esportivo ajustado ao corpo.',
      price: 139.90,
      promotional_price: null,
      sku: 'URB-ML-UV50',
      gender: 'Unissex',
      featured: 0,
      rating_avg: 5.0,
      rating_count: 12,
      images: [
        { url: '/assets/products/camisa-manga-longa.svg', is_primary: 1 }
      ],
      variants: [
        { size: 'P', color: 'Grafite Carbon', color_hex: '#141c17', gender: 'Unissex', stock: 7, sku: 'URB-ML-P-GRA' },
        { size: 'M', color: 'Grafite Carbon', color_hex: '#141c17', gender: 'Unissex', stock: 14, sku: 'URB-ML-M-GRA' },
        { size: 'G', color: 'Grafite Carbon', color_hex: '#141c17', gender: 'Unissex', stock: 11, sku: 'URB-ML-G-GRA' },
        { size: 'GG', color: 'Grafite Carbon', color_hex: '#141c17', gender: 'Unissex', stock: 5, sku: 'URB-ML-GG-GRA' }
      ]
    },
    {
      id: 'prod_bone_laser',
      category_id: 'cat_bones',
      name: 'Boné Running Laser Tech URB',
      slug: 'bone-running-laser-tech-urb',
      short_description: 'Perfurações a laser para fluxo de ar contínuo, faixa anti-suor e fecho ergonômico.',
      description: 'Um dos itens mais aclamados da comunidade URBRACE. Pesa menos de 50 gramas, conta com furos geométricos a laser nas laterais para expulsar o calor e aba semi-flexível que não deforma mesmo após sucessivas lavagens.',
      technical_info: 'Material: Poliéster Hydrophobic Ripstop. Faixa interna atoalhada com tecnologia QuickDry. Ajuste elástico milimétrico com fecho magnético.',
      size_guide: 'Tamanho Único regulável (circunferência de 54cm a 62cm).',
      price: 89.90,
      promotional_price: 69.90,
      sku: 'URB-BON-LASER',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 52,
      images: [
        { url: '/images/produtos/bone-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: 'Único', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 35, sku: 'URB-BON-BLK' },
        { size: 'Único', color: 'Verde Neon Flash', color_hex: '#b0ff00', gender: 'Unissex', stock: 22, sku: 'URB-BON-NEO' }
      ]
    },
    {
      id: 'prod_viseira_aerotech',
      category_id: 'cat_bones',
      name: 'Viseira Aerotech URBRACE',
      slug: 'viseira-aerotech-urbrace',
      short_description: 'Estrutura curva de alta aerodinâmica com aba flexível anti-reflexo.',
      description: 'Ideal para dias ensolarados em que você quer manter a cabeça livre e o campo de visão totalmente protegido dos raios solares. Aba com forro antirreflexo preto e elástico super macio que não aperta.',
      technical_info: 'Tecido leve de secagem rápida com elástico revestido. Logo frontal em transfer reflexivo de alta densidade.',
      size_guide: 'Tamanho Único com ajuste flexível adaptativo.',
      price: 69.90,
      promotional_price: null,
      sku: 'URB-VIS-AERO',
      gender: 'Unissex',
      featured: 0,
      rating_avg: 4.7,
      rating_count: 19,
      images: [
        { url: '/images/produtos/viseira-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: 'Único', color: 'Grafite Carbon', color_hex: '#151d18', gender: 'Unissex', stock: 18, sku: 'URB-VIS-GRA' },
        { size: 'Único', color: 'Preto Stealth', color_hex: '#0d120f', gender: 'Unissex', stock: 25, sku: 'URB-VIS-BLK' }
      ]
    },
    {
      id: 'prod_meia_21k',
      category_id: 'cat_meias',
      name: 'Meia Compressão 21K Pro Speed',
      slug: 'meia-compressao-21k-pro-speed',
      short_description: 'Graduação de compressão 15-20 mmHg para redução de fadiga e suporte plantar.',
      description: 'Desenvolvida em parceria com médicos do esporte e corredores de meia maratona. A compressão graduada estimula o retorno venoso, estabiliza a panturrilha e atrasa a sensação de queimação muscular.',
      technical_info: 'Composição: 85% Poliamida, 15% Elastano. Faixa elástica central no arco do pé. Biqueira sem costura para zero atrito com os dedos.',
      size_guide: '35-38 (Calçados 35 ao 38)\n39-43 (Calçados 39 ao 43)',
      price: 59.90,
      promotional_price: 49.90,
      sku: 'URB-MEI-21K',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 45,
      images: [
        { url: '/images/produtos/meia-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: '35-38', color: 'Preto com Neon', color_hex: '#0d120f', gender: 'Unissex', stock: 20, sku: 'URB-MEI-3538-BLK' },
        { size: '39-43', color: 'Preto com Neon', color_hex: '#0d120f', gender: 'Unissex', stock: 32, sku: 'URB-MEI-3943-BLK' }
      ]
    },
    {
      id: 'prod_meia_curta',
      category_id: 'cat_meias',
      name: 'Meia Cano Curto Anti-Bolha Run',
      slug: 'meia-cano-curto-anti-bolha-run',
      short_description: 'Dupla camada anti-atrito com acolchoamento estratégico no calcanhar.',
      description: 'Esqueça as bolhas pós-longão. O tecido especial dissipa o calor gerado pela pisada e absorve os impactos no calcanhar e metatarso.',
      technical_info: 'Composição: 80% Algodão Premium Penteado, 17% Poliamida, 3% Elastano. Abas de calcanhar para calce rápido e proteção do tendão de Aquiles.',
      size_guide: 'Tamanhos 35-38 e 39-43.',
      price: 34.90,
      promotional_price: null,
      sku: 'URB-MEI-CURTA',
      gender: 'Unissex',
      featured: 0,
      rating_avg: 4.6,
      rating_count: 18,
      images: [
        { url: '/assets/products/meia-cano-curto.svg', is_primary: 1 }
      ],
      variants: [
        { size: '35-38', color: 'Branco', color_hex: '#ffffff', gender: 'Unissex', stock: 25, sku: 'URB-MC-3538-WHT' },
        { size: '39-43', color: 'Branco', color_hex: '#ffffff', gender: 'Unissex', stock: 30, sku: 'URB-MC-3943-WHT' },
        { size: '39-43', color: 'Preto', color_hex: '#0d120f', gender: 'Unissex', stock: 40, sku: 'URB-MC-3943-BLK' }
      ]
    },
    {
      id: 'prod_manguito_uv',
      category_id: 'cat_manguitos',
      name: 'Manguito Compressão Térmico UV Pro',
      slug: 'manguito-compressao-termico-uv-pro',
      short_description: 'Firmeza muscular com controle térmico e proteção solar para treinos longos.',
      description: 'O manguito URBRACE ajusta-se confortavelmente aos braços, evitando oscilações musculares desnecessárias e protegendo contra queimaduras solares ou quedas de temperatura repentinas.',
      technical_info: 'Silicone anti-deslizante na borda superior. Tecido térmico inteligente que resfria com o vento.',
      size_guide: 'P/M: Bíceps de 24 a 32cm\nG/GG: Bíceps de 33 a 42cm',
      price: 64.90,
      promotional_price: 54.90,
      sku: 'URB-MAN-PRO',
      gender: 'Unissex',
      featured: 0,
      rating_avg: 4.8,
      rating_count: 29,
      images: [
        { url: '/images/produtos/manguito-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: 'P/M', color: 'Preto Stealth', color_hex: '#0e1410', gender: 'Unissex', stock: 16, sku: 'URB-MAN-PM-BLK' },
        { size: 'G/GG', color: 'Preto Stealth', color_hex: '#0e1410', gender: 'Unissex', stock: 20, sku: 'URB-MAN-GGG-BLK' },
        { size: 'P/M', color: 'Verde Neon', color_hex: '#b0ff00', gender: 'Unissex', stock: 14, sku: 'URB-MAN-PM-NEO' },
        { size: 'G/GG', color: 'Verde Neon', color_hex: '#b0ff00', gender: 'Unissex', stock: 18, sku: 'URB-MAN-GGG-NEO' }
      ]
    },
    {
      id: 'prod_cinto_hidratacao',
      category_id: 'cat_acessorios',
      name: 'Cinto de Hidratação Pro URB 500ml',
      slug: 'cinto-de-hidratacao-pro-urb-500ml',
      short_description: 'Design bounce-free com 2 garrafas ergonômicas de 250ml e bolso celular até 6.8".',
      description: 'Desenvolvido para corridas de 10K, meia maratona e maratona completa. Não pula durante a passada graças ao elástico de dupla tensão e costura anatômica que acompanha a cintura.',
      technical_info: 'Inclui 2 garrafas livres de BPA de 250ml cada. Bolso central resistente à água com zíper selado. Presilhas elásticas para fixação de número de peito de corrida.',
      size_guide: 'P/M: Cinturas de 66cm a 84cm\nG/GG: Cinturas de 85cm a 108cm',
      price: 129.90,
      promotional_price: 109.90,
      sku: 'URB-ACC-CINTO',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 31,
      images: [
        { url: '/images/produtos/pochete-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: 'P/M', color: 'Preto com Neon', color_hex: '#101712', gender: 'Unissex', stock: 15, sku: 'URB-CINTO-PM' },
        { size: 'G/GG', color: 'Preto com Neon', color_hex: '#101712', gender: 'Unissex', stock: 22, sku: 'URB-CINTO-GGG' }
      ]
    },
    {
      id: 'prod_bracadeira_touch',
      category_id: 'cat_acessorios',
      name: 'Braçadeira Porta Celular Touch URB',
      slug: 'bracadeira-porta-celular-touch-urb',
      short_description: 'Neoprene impermeável, visor touch capacitivo e saída para chave.',
      description: 'Mantenha suas métricas e músicas ao alcance do braço com firmeza e sem suor no aparelho. O visor transparente mantém a sensibilidade touch de telas OLED e LCD.',
      technical_info: 'Neoprene elástico respirável. Compatível com smartphones até 6.8 polegadas. Faixa reflexiva 360 graus.',
      size_guide: 'Tamanho Único regulável com fecho de velcro de alta aderência.',
      price: 49.90,
      promotional_price: null,
      sku: 'URB-ACC-BRAC',
      gender: 'Unissex',
      featured: 0,
      rating_avg: 4.7,
      rating_count: 15,
      images: [
        { url: '/assets/products/bracadeira-touch.svg', is_primary: 1 }
      ],
      variants: [
        { size: 'Único', color: 'Preto Stealth', color_hex: '#131915', gender: 'Unissex', stock: 28, sku: 'URB-BRAC-BLK' }
      ]
    },
    {
      id: 'prod_kit_maratona',
      category_id: 'cat_kits',
      name: 'Kit Oficial Maratona URBRACE',
      slug: 'kit-oficial-maratona-urbrace',
      short_description: 'Combo definitivo: Camisa Dry-Fit + Boné Laser + Meia 21K + Gymbag URB exclusiva.',
      description: 'O pacote completo dos corredores de elite da URBRACE. Reúne todos os itens indispensáveis para os seus maiores desafios com desconto especial de combo.',
      technical_info: 'Contém: 1 Camisa Performance Dry-Fit, 1 Boné Laser Tech, 1 Meia Compressão 21K e 1 Mochila Saco Gymbag URBRACE impermeável com bolso interno.',
      size_guide: 'Escolha o tamanho da Camisa e Meia nas variações abaixo.',
      price: 269.90,
      promotional_price: 229.90,
      sku: 'URB-KIT-MARA',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 5.0,
      rating_count: 67,
      images: [
        { url: '/assets/products/kit-maratona.svg', is_primary: 1 }
      ],
      variants: [
        { size: 'P', color: 'Drop Oficial Preto/Neon', color_hex: '#0b0f0d', gender: 'Unissex', stock: 12, sku: 'URB-KIT-P' },
        { size: 'M', color: 'Drop Oficial Preto/Neon', color_hex: '#0b0f0d', gender: 'Unissex', stock: 19, sku: 'URB-KIT-M' },
        { size: 'G', color: 'Drop Oficial Preto/Neon', color_hex: '#0b0f0d', gender: 'Unissex', stock: 15, sku: 'URB-KIT-G' },
        { size: 'GG', color: 'Drop Oficial Preto/Neon', color_hex: '#0b0f0d', gender: 'Unissex', stock: 8, sku: 'URB-KIT-GG' }
      ]
    },
    {
      id: 'prod_kit_night_run',
      category_id: 'cat_kits',
      name: 'Kit Treino Noturno Neon Pack',
      slug: 'kit-treino-noturno-neon-pack',
      short_description: 'Visibilidade e performance: Regata Pro + Manguito UV + Viseira em alta refletividade.',
      description: 'Pensado para os pelotões noturnos urbanos. Materiais de alta visibilidade que refletem a iluminação dos faróis e luzes da cidade, garantindo total segurança durante o treino.',
      technical_info: 'Contém: 1 Regata Pro Marathon, 1 Par de Manguitos UV Pro e 1 Viseira Aerotech.',
      size_guide: 'Tamanhos P, M, G, GG de acordo com a modelagem oficial.',
      price: 199.90,
      promotional_price: 169.90,
      sku: 'URB-KIT-NIGHT',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 19,
      images: [
        { url: '/assets/products/kit-neon-pack.svg', is_primary: 1 }
      ],
      variants: [
        { size: 'P', color: 'Verde Neon/Preto', color_hex: '#0f1411', gender: 'Unissex', stock: 10, sku: 'URB-KN-P' },
        { size: 'M', color: 'Verde Neon/Preto', color_hex: '#0f1411', gender: 'Unissex', stock: 14, sku: 'URB-KN-M' },
        { size: 'G', color: 'Verde Neon/Preto', color_hex: '#0f1411', gender: 'Unissex', stock: 12, sku: 'URB-KN-G' },
        { size: 'GG', color: 'Verde Neon/Preto', color_hex: '#0f1411', gender: 'Unissex', stock: 6, sku: 'URB-KN-GG' }
      ]
    },
    {
      id: 'prod_garrafa_termica',
      category_id: 'cat_acessorios',
      name: 'Garrafa Térmica Squeeze Pro URB 750ml',
      slug: 'garrafa-termica-squeeze-pro-urb-750ml',
      short_description: 'Aço inoxidável com isolamento a vácuo de parede dupla. Mantém gelado por 24h.',
      description: 'Desenvolvida com aço inox 18/8 de grau alimentício, a Garrafa Térmica URB garante hidratação gelada durante treinos longos e dias quentes de prova. Tampa ergonômica com bico rápido e trava anti-vazamento.',
      technical_info: 'Capacidade: 750ml. Material: Aço Inoxidável 18/8 livre de BPA. Térmica: até 24h gelado / 12h quente.',
      size_guide: 'Dimensões: 26cm x 7.5cm. Peso: 320g.',
      price: 79.90,
      promotional_price: 64.90,
      sku: 'URB-GAR-750',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.9,
      rating_count: 41,
      images: [
        { url: '/images/produtos/garrafa-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: '750ml', color: 'Preto Fosco', color_hex: '#0e1310', gender: 'Unissex', stock: 30, sku: 'URB-GAR-BLK' },
        { size: '750ml', color: 'Verde Neon', color_hex: '#b0ff00', gender: 'Unissex', stock: 25, sku: 'URB-GAR-NEO' }
      ]
    },
    {
      id: 'prod_toalha_ice',
      category_id: 'cat_acessorios',
      name: 'Toalha Esportiva Ice Dry URBRACE',
      slug: 'toalha-esportiva-ice-dry-urbrace',
      short_description: 'Microfibra de resfriamento instantâneo de alta absorção e secagem ultrarrápida.',
      description: 'Basta molhar, torcer e agitar para ativar o resfriamento por evaporação. Perfeita para baixar a temperatura corporal pós-prova ou durante treinos sob sol intenso.',
      technical_info: 'Composição: 85% Poliéster, 15% Poliamida. Fator de proteção UV50+. Acompanha estojo de silicone ventilado.',
      size_guide: 'Dimensões: 100cm x 30cm.',
      price: 44.90,
      promotional_price: 39.90,
      sku: 'URB-TOA-ICE',
      gender: 'Unissex',
      featured: 1,
      rating_avg: 4.8,
      rating_count: 28,
      images: [
        { url: '/images/produtos/toalha-urb.png', is_primary: 1 }
      ],
      variants: [
        { size: 'Único', color: 'Grafite Carbon', color_hex: '#151d18', gender: 'Unissex', stock: 40, sku: 'URB-TOA-GRA' }
      ]
    }
  ];
